import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { SkillResponse, DepartmentResult, CategoryResult } from '../api-interfaces';
import { SkillService } from '../services/skill.service';
import 'rxjs/add/operator/takeUntil';
import { Subject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { FlashService } from '../../flash/flash.service';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IMultiSelectSettings } from 'angular-2-dropdown-multiselect';

@Component({
  selector: 'app-list-skill',
  templateUrl: './list-skill.component.html',
  styleUrls: ['./list-skill.component.css']
})

export class ListSkillComponent implements OnInit {

  skills: Observable<SkillResponse[]>;
  skillList: Observable<SkillResponse[]>;
  departmentList: DepartmentResult[] = [];
  categoryList: CategoryResult[] = [];
  filterSkill={};
  private destroy: Subject<void> = new Subject<void>();
  editData = [];
  searchResult: Observable<any>;
  searchQuery$: Observable<any>;
  searchText: FormControl;
  skillForm: FormGroup;
  departmentId;
  categoryId;
  selectedDepartment: any = [];
  selectedCategories: any = [];

  mySettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'checkboxes',
    buttonClasses: 'btn btn-default btn-block',
    maxHeight: '200px',
    displayAllSelectedText: false,
    dynamicTitleMaxItems: 100
  };

  constructor(
    public skillService: SkillService,
    public router: Router,
    private flashService: FlashService,
    private spinnerService: Ng4LoadingSpinnerService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private changeDetector: ChangeDetectorRef,

  ) {
    this.spinnerService.show();
    this.skills = this.skillService.getSkill();
    this.skillList = this.skillService.getCategoryBySkill();
    this.spinnerService.hide();

    this.searchText = new FormControl('');
    this.searchQuery$ = this.searchText.valueChanges.startWith('');
    this.filterSkillList();

    this.skillForm = this.formBuilder.group({
      search_text:  new FormControl('', Validators.required),
      department_drop: new FormControl(''),
      category_drop: new FormControl('')
    });
  }
  async ngOnInit() {
    this.categoryId = this.route.snapshot.queryParamMap.get('categoryId');
    this.departmentId = this.route.snapshot.queryParamMap.get('departmentId');

    await this.getCategoryByDepartment([+this.departmentId]);

    this.getSkillList([+this.departmentId],[+this.categoryId], '')

    this.selectedDepartment = this.departmentId ? [+this.departmentId] : this.selectedDepartment;
    this.selectedCategories = this.categoryId ? [+this.categoryId] : this.selectedCategories;

  }
  ngOnChanges(){
  }

  userSelectDepartmentListner(event) {
    this.categoryList = [];
    if(!!event && event.length > 0) {
      // event.forEach(depId => {
      //   this.getCategoryByDepartmentId(depId);
      // });
      this.departmentListnerFilter(event);
    } else {
      this.skillForm.controls.category_drop.reset();
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.unsubscribe();
  }

  filterSkillList(){
    this.searchResult = this.searchQuery$.combineLatest(this.skills)
    .map(([query, searchList]) => {
      return searchList.filter(state => state.skill_name
      .toLowerCase().indexOf(query.toLowerCase()) !== -1)
    })
  }

  goToEdit(id, departmentId ) {
    this.skillService.editDataSkill = departmentId;
    this.router.navigate(['/skill/edit/', id]);
  }

  goToFilter( skillId, categoryId, departmentId) {
    this.router.navigate(['/adminFilter'], {
      queryParams: {
        filter: 'by-skill',
        skillId: skillId,
        categoryId: categoryId,
        departmentId: departmentId
      },
      queryParamsHandling: 'merge'
    });
  }

  deleteSkill(skill_id, skillName, catId) {
    this.spinnerService.show();
    this.skillService.deleteSkill(skill_id, skillName, catId).takeUntil(this.destroy).subscribe(
      response => {
        this.spinnerService.hide();
        if(response['status'] === true){
          this.flashService.show(response['message'].replace('Success', 'Skill deactivate successfully'), 'alert-success');
          this.filterSkillList();
          this.searchResult = this.skillService.getCategoryBySkill(this.filterSkill)
        }
      },
      error => {
        this.spinnerService.hide();
        this.flashService.show(error['error']['message'], 'alert-danger');
      });
  }

  getSkillList(departmentId, categoryId, skillName) {
     this.filterSkill = {
      "department_id": departmentId ? departmentId : [] ,
      "category_id": categoryId ? categoryId : [],
      "skill_name": skillName ? skillName : ''
    }

    this.searchResult = this.skillService.getCategoryBySkill(this.filterSkill)
  }

  async getCategoryByDepartment(departmentId) {
    await this.skillService.getCategoryDepartment().takeUntil(this.destroy)
    .toPromise().then(data => {
       this.departmentList = data;
       this.departmentList.forEach((res, index) => {
        this.departmentList[index].name = res.department_name;
        this.departmentList[index].id = res.department_id;
      })
       if (departmentId) {
         this.getCategoryByDepartmentId(departmentId)
       }
    });
    this.changeDetector.detectChanges();
  }

  async getCategoryByDepartmentId(departmentid_element) {
    let cat = this.departmentList;
    for ( let ch in cat ) {
      if ( cat[ch].department_id == departmentid_element ) {
        // this.categoryList = cat[ch].category;
        let selectDepCategories = [];
        selectDepCategories = cat[ch].category;
        selectDepCategories.forEach((res, index) => {
          selectDepCategories[index].name = res.category_name;
          selectDepCategories[index].id = res.category_id;
        });

        const concatAllselectedCat = !!this.categoryList ? selectDepCategories.concat(this.categoryList) : selectDepCategories;
        // Filtering duplicate array.
        this.categoryList = concatAllselectedCat.filter((set => f => !set.has(f.category_id) && set.add(f.category_id))(new Set));
        this.changeDetector.detectChanges();
        break;
      }
    }
  }

  enableTheSkill(id) {
    this.spinnerService.show();
    this.skillService.skillEnable(id).subscribe(res => {
      if (!!res.status) {
        this.spinnerService.hide();
        this.flashService.show(res.message.replace('Success', 'skill activate successfully'), 'alert-success');
        this.filterSkillList();
        this.searchResult = this.skillService.getCategoryBySkill(this.filterSkill)
      }
    }, error => {
      this.spinnerService.hide();
      this.flashService.show(error['error']['message'], 'alert-danger');
    });
  }

  trackByFn(index) {
    return index;
  }

    /**
   * @param item
   * @param source
   * @description Get active selected item from parent dropdown
   *  then compare by ID and update in the selected item like category dropdown.
   */
  selectedItemUpdation(item: number[], source: number[]) {
    const sourceItem = item.concat(source);
    return sourceItem.filter((s => v => s.has(v) || !s.add(v))(new Set));;
  }

  /**
   * @param depIDs
   * @description Get the allcategory list from selected department once done await forloop
   *  then show selected skill.
   */
  async departmentListnerFilter(depIDs: number[]) {
    await depIDs.forEach(async depId => {
      await this.getCategoryByDepartmentId(depId);
    });
    this.selectedCategories =  this.selectedCategories && this.selectedCategories.length > 0 ?
      this.selectedItemUpdation(this.selectedCategories, this.categoryList.map(res => res.category_id)) : this.selectedCategories;
    this.changeDetector.detectChanges();
  }
}



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/skill-matrix/list-skill/list-skill.component.ts